var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-shrink",class:{hide: _vm.hideDetails},attrs:{"id":"user-details"}},[(_vm.section === 'info')?_c('ContactDetails'):_vm._e(),(_vm.section === 'notes')?_c('UserNotes'):_vm._e(),(_vm.section === 'properties')?_c('UserProperties'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }